export default function AudioPlayer({ url }: { url: string }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-3">
      <audio controls className="w-full" preload="metadata">
        <source src={url} />
        Il tuo browser non supporta l'audio HTML5.
      </audio>
    </div>
  );
}
